import { Token } from './Token';
import { berachainTestnetbArtio } from 'viem/chains';

import { UsdcLogo, UsdtLogo, WbtcLogo, WethLogo, WstEthLogo } from '../assets/svg/tokens';
import HoneyLogo from '../assets/png/honey.png'
import BeraLogo from '../assets/png/BERA.png'
import iBGTLogo from '../assets/png/iBGT.png'

import { Address } from 'viem';

const HONEY_BERA = new Token(
  berachainTestnetbArtio.id,
  '0x0e4aaf1351de4c0264c5c7056ef3777b41bd8e03',
  18,
  'HONEY',
  'Honey',
  HoneyLogo
);

const WBERA_BERA = new Token(
  berachainTestnetbArtio.id,
  '0x7507c1dc16935B82698e4C63f2746A2fCf994dF8',
  18,
  'WBERA',
  'Wrapped BERA',
  BeraLogo
);

const IBGT_BERA = new Token(
  berachainTestnetbArtio.id,
  '0xac03caba51e17c86c921e1f6cbfbdc91f8bb2e6b',
  18,
  'iBGT',
  'Infrared BGT',
  iBGTLogo
);

// const USDC_BERA = new Token(
//   berachainTestnetbArtio.id,
//   '0xd6d83af58a19cd14ef3cf6fe848c9a4d21e5727c',
//   6,
//   'USDC',
//   'USD Coin',
//   UsdcLogo
// );

// const WBTC_BERA = new Token(
//   berachainTestnetbArtio.id,
//   '0x2577d24a26f8fa19c1058a8b0106e2c7303454a4',
//   8,
//   'WBTC',
//   'Wrapped Bitcoin',
//   WbtcLogo
// );

// const WETH_BERA = new Token(
//   berachainTestnetbArtio.id,
//   '0xe28afd8c634946833e89ee3f122c06d7c537e8a8',
//   18,
//   'wETH',
//   'Wrapped Ether',
//   WstEthLogo
// );


const TOKEN_DATA: { [chainId: number]: { [address: Address]: Token } } = {
  [berachainTestnetbArtio.id]: {
    [HONEY_BERA.address.toLowerCase()]: HONEY_BERA,
    [WBERA_BERA.address.toLowerCase()]: WBERA_BERA,
    [IBGT_BERA.address.toLowerCase()]: IBGT_BERA,
    // [USDC_BERA.address.toLowerCase()]: USDC_BERA,
    // [WBTC_BERA.address.toLowerCase()]: WBTC_BERA,
    // [WETH_BERA.address.toLowerCase()]: WETH_BERA,
  },
};

export function getTokens(chainId: number): Token[] {
  return Array.from(Object.values(TOKEN_DATA[chainId]));
}

export function getToken(chainId: number, address: Address): Token | undefined {
  return TOKEN_DATA[chainId][getLowercaseAddress(address)];
}

export function getTokenBySymbol(chainId: number, symbol: string): Token | undefined {
  return Object.values(TOKEN_DATA[chainId]).find((token) => token.symbol.toUpperCase() === symbol.toUpperCase());
}

function getLowercaseAddress(address: Address): Address {
  return address.toLowerCase() as Address;
}
